import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VBtn,{attrs:{"icon":"","title":"Visualizar resultado da exportação para o Protheus"},on:{"click":function($event){_setup.dialog_ativo = true}}},[_c(VIcon,[_vm._v("mdi-file-eye")])],1),_c(_setup.DialogResultadoExportacao,{attrs:{"resultado":_setup.resultado_exportacao},model:{value:(_setup.dialog_ativo),callback:function ($$v) {_setup.dialog_ativo=$$v},expression:"dialog_ativo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }